<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let direction: string;
  export let extraClass = "";
  $: up = direction == "up" || direction == "ASC";
  $: down = direction == "down" || direction == "DESC";
  $: left = direction == "left";
  $: right = direction == "right";

</script>

<span
  class={`margin-left--smallest ${extraClass}`}
  class:arrow--up={up}
  class:arrow--down={down}
  class:arrow--left={left}
  class:arrow--right={right}
>
  <Icon type="ArrowSpinnable" width="10" height="10" />
</span>
